import { useMutation } from '@tanstack/react-query';
import { RolesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useRolesControllerUpdateRoleMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['rolesControllerUpdateRole', accessControlScope],
        mutationFn: async (args) => {
            const api = new RolesApi(accessControlConfig);
            return api.rolesControllerUpdateRole(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useRolesControllerUpdateRoleMutation.js.map